<script lang="ts">
export default {
    name: 'BasePopupMask',
};
</script>

<script setup lang="ts">
import { computed } from 'vue-demi';

interface Props {
    transparent?: boolean;
    background?: string;
}

const props = withDefaults(defineProps<Props>(), {
    transparent: false,
});

const emit = defineEmits<{
    (event: 'click'): void;
}>();

const maskStyle = computed(() => {
    return {
        background: props.transparent ? 'transparent' : props.background,
    };
});
</script>

<template>
    <div class="mask" :style="maskStyle" @click="$emit('click')" @touchmove.prevent></div>
</template>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background: rgba(0, 0, 0, 0.85);
}
</style>
